import { ComponentType } from '@angular/cdk/portal';
import { InjectionToken, StaticProvider, TemplateRef } from '@angular/core';

interface CreateNewTeamDialogData {
  component: ComponentType<unknown> | TemplateRef<unknown>;
  providers: StaticProvider[] | (() => StaticProvider[]);
  onSubmit?: () => void;
}

export const CRATE_NEW_TEAM_DIALOG_TOKEN = new InjectionToken<CreateNewTeamDialogData>(
  'Create new team dialog token for recent projects page'
);
